export function sleep(second) {
    return new Promise((resolve) => {
        // @ts-ignore
        setTimeout(resolve, 1000 * second);
    });
}
